import { AccessChecker } from 'mycorems-app-accounts';
import rules from './rules';

const accessChecker = new AccessChecker(rules, 'mycorems_accounts');

export default function (action: string, ...args: any[]): boolean {
  return accessChecker.isGranted(action, ...args);
}
